import { useValue } from "tldraw"
import { useCurrentPage } from "./useCurrentPage"
import { LayerId } from "../../shared/Layer"

export function useCurrentLayerId(): LayerId {
  const currentPage = useCurrentPage()

  const currentLayerId = useValue(
    "currentLayerId",
    () => currentPage.meta.currentLayer,
    [currentPage],
  )

  return currentLayerId
}

export function useCurrentLayer() {
  const currentPage = useCurrentPage()

  const currentLayerId = useCurrentLayerId()

  return currentPage.meta.layers[currentLayerId]
}
